export interface ColFilter {
  colKey: string;
  filterTerm: string;
  colProperty?: string;
  operator?: string;
}

export enum LogicalOperator {
  AND = "AND",
  OR = "OR",
}

export interface ColFilterGroup {
  colKey: string;
  logicalOperator: LogicalOperator;
  conditions: ColFilterNode[];
}

export type ColFilterNode = ColFilter | ColFilterGroup;

export function isColFilterGroup(node: ColFilterNode): node is ColFilterGroup {
  return Array.isArray((node as ColFilterGroup).conditions);
}

/** Every leaf condition below `nodes`, depth-first, ignoring how the groups combine them. */
export function colFilterLeaves(nodes: readonly ColFilterNode[]): ColFilter[] {
  return nodes.flatMap((node) => (isColFilterGroup(node) ? colFilterLeaves(node.conditions) : [node]));
}

export enum FilterOperator {
  EQUALS = "EQ",
  NOT_EQUALS = "NEQ",
  GREATER_THAN = "GT",
  LESS_THAN = "LT",
  GREATER_OR_EQUALS = "GTE",
  LESS_OR_EQUALS = "LTE",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  STARTS_WITH = "STARTS_WITH",
  ENDS_WITH = "ENDS_WITH",
  BLANK = "BLANK",
  NOT_BLANK = "NOT_BLANK",
  /** Editor only (Between on dates and numbers): encoded as GTE + LTE, never sent. */
  IN_RANGE = "IN_RANGE",
}

export type WireFilterOperator = Exclude<FilterOperator, FilterOperator.IN_RANGE>;
